import React, { useCallback, useEffect, useRef } from "react";
import { getTicketIcon } from "../containers/Home/containers/helpers";
import { TicketTypeButton } from "./TicketTypeButton";
import { TicketStatusButton } from "./TicketStatusButton";
import { AssigneeButton } from "./AssigneeButton";
import { CalendarButton } from "./CalendarButton";
import { PriorityButton } from "./PriorityButton";
import TagsButton from "./TagsButton";
import { TicketGroup, TicketType } from "../types";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions } from "../containers/Tickets/redux/slice";
import { selectTicketCreateLoading, selectTicketFormDetail } from "../containers/Tickets/redux/selector";
import { useParams } from "react-router-dom";
import EnterIcon from "assets/svgs/ic_enter.svg";

interface CreateTicketRowProps {
  readonly selectedType: TicketType;
  readonly onCancel: () => void;
  setSelectedValue: (value: TicketType) => void;
  onShowAddTask: () => void;
  groupId?: string;
  groupBy?: string;
  defaultGroup?:TicketGroup
}

export default function CreateTicketRow({
  selectedType,
  onCancel,
  setSelectedValue,
  onShowAddTask,
  groupId = "",
  groupBy,
  defaultGroup
}: CreateTicketRowProps) {
  const params = useParams();
  const dispatch = useDispatch();
  const form = useSelector(selectTicketFormDetail);
  const loading = useSelector(selectTicketCreateLoading)
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, [onShowAddTask]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(
      actions.setTicketFormValue({
        name: name,
        value: value,
      })
    );
  };

  const handleCreateTicket = () => {
      dispatch(
        actions.setCreateTicket({
          projectId: params.project as string,
           boardId:params.id as string,
           groupId: groupId,
          callback: () => {
            onCancel();
            onShowAddTask();
          },
        })
      );
  };

const handleInputKeyDown = useCallback(
  (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleCreateTicket();
    } else if (e.key === "Escape") {
      onCancel();
    }
  },
  [handleCreateTicket, onCancel]
);

  return (
    <td colSpan={1} className="p-0 w-full">
      <div className="h-[36px] bg-white w-full flex flex-row items-center overflow-hidden">
        <div className="p-[4px] flex-grow">
          <div className="flex flex-row items-center gap-[4px]">
            <div className="min-w-[20px]">
              <img
                src={getTicketIcon(selectedType)}
                alt="task-icon"
                className="size-[20px]"
              />
            </div>
            <input
              type="text"
              name="title"
              ref={inputRef}
              value={form?.title}
              onChange={(e) => handleChange(e)}
              className="w-full text-sm leading-[21px] font-normal focus:outline-none"
              placeholder={`Enter ${selectedType.toLowerCase()} name`}
              onKeyDown={handleInputKeyDown}
              
            />
          </div>
        </div>
        <div className="p-[4px] flex flex-row items-center flex-shrink-0">
          <div className="flex flex-row items-center gap-[10px]">
            <div className="flex flex-row items-center gap-[6px]">
              <TicketTypeButton
                type={selectedType}
                onTypeChange={(selectedType: TicketType) => {
                  setSelectedValue(selectedType);
                }}
                onShowAddTask={onShowAddTask}
              />
              <TicketStatusButton onShowAddTask={onShowAddTask}  
                defaultGroup={defaultGroup}
                groupBy={groupBy}
              />
              <AssigneeButton/>
              <CalendarButton />
              <PriorityButton />
              <TagsButton />
            </div>
            <div className="flex flex-row items-center gap-[6px]">
              <button
                className="flex items-center justify-center h-[28px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary px-[10px] hover:bg-[#ECEEF2] hover:text-[#79808A] hover:border-[#E9ECF2] transition-all duration-200"
                onClick={onCancel}
              >
                Cancel
              </button>
              
              <button
                className={`flex items-center justify-center h-[28px] rounded-[4px] text-xs leading-[18px] font-medium px-[10px] gap-1
                  ${!form?.title?.length 
                    ? 'bg-[#5A8DF1] text-white opacity-30 cursor-not-allowed' 
                    : 'text-white bg-[#5A8DF1]'}`} 
                onClick={() => handleCreateTicket()}
                disabled={!form?.title?.length}
              >
                  {loading && (
                      <div className="flex items-center justify-center">
                        <div className="w-3 h-3 border-t-2 border-white border-solid rounded-full animate-spin" />
                      </div>
                  )}
                       Save
                  <img src={EnterIcon} alt={EnterIcon} sizes="20px" />
              </button> 
            </div>
          </div>
        </div>
      </div>
    </td>
  );
}
